<div [ngSwitch]="content.level">
  <ng-container *ngSwitchCase="'1'">
    <h1
      class="idp__banner__heading"
      [ngStyle]="styles"
      [ngClass]="headingClass"
      *ngIf="config.visible"
      [innerHtml]="content.text"
    ></h1>
  </ng-container>
  <ng-container *ngSwitchCase="'2'">
    <h2
      class="idp__banner__heading"
      [ngStyle]="styles"
      [ngClass]="headingClass"
      *ngIf="config.visible"
      [innerHtml]="content.text"
    ></h2>
  </ng-container>
  <ng-container *ngSwitchCase="'3'">
    <h3
      class="idp__banner__heading"
      [ngStyle]="styles"
      [ngClass]="headingClass"
      *ngIf="config.visible"
      [innerHtml]="content.text"
    ></h3>
  </ng-container>
  <ng-container *ngSwitchCase="'4'">
    <h4
      class="idp__banner__heading"
      [ngStyle]="styles"
      [ngClass]="headingClass"
      *ngIf="config.visible"
      [innerHtml]="content.text"
    ></h4>
  </ng-container>
  <ng-container *ngSwitchCase="'5'">
    <h5
      class="idp__banner__heading"
      [ngStyle]="styles"
      [ngClass]="headingClass"
      *ngIf="config.visible"
      [innerHtml]="content.text"
    ></h5>
  </ng-container>
  <ng-container *ngSwitchCase="'6'">
    <h6
      class="idp__banner__heading"
      [ngStyle]="styles"
      [ngClass]="headingClass"
      *ngIf="config.visible"
      [innerHtml]="content.text"
    ></h6>
  </ng-container>
</div>
